import { on_ready, is_elementor_edit } from 'js/utils';
import { init_retina } from 'js/retina';
import { init_toggle_height } from 'js/toggle_height_init';

import { init_header } from 'modules/header/header';
import init_forms from 'modules/forms/forms';
import init_carousels from 'modules/carousel/carousel';
import init_footer from 'modules/footer/footer';
import init_nav_menu from 'modules/menu/nav/nav';

import { load_swiper_mobile } from 'modules/carousel/load_swiper_mobile';


// load global styles
import './main.scss';

document.addEventListener('swiper_mobile_ready',(e)=>{
    new e.Swiper_Mobile({
        container: '.swiper_on_mobile',
        items: '.item',
        arrows: true,
    })
})

on_ready(()=>{

    init_footer();

    if( is_elementor_edit() ) return;
    
    // forms ui + gravityforms customizations
    // move outside of tasks queue, have issues with hooks registered late
    init_forms();

    init_header();

    init_nav_menu();

    init_carousels(); // swiper

    init_retina(); // @images

    init_toggle_height(); // toggle element height from 0 to default - for animating height

    // on_mobile();

    mobile_read_more();

     load_swiper_mobile();
    
    init_dynamic_load();
    
    document.dispatchEvent(new Event('after_main_init'));
});

// function on_mobile(){
//     if( window.innerWidth > 768 ) return;
// }

function init_dynamic_load(){

    // search popup: remove if not used
    // if( document.querySelector('.search_popup_open') ) {
    //     import('modules/search/search_popup/init');
    // }
    
    // burger / mobile menu: remove if not used
    if( document.querySelector('.slide_menu_open') ) {
        import('modules/menu/slide_menu/init');
    }

    // wishlist & compare: remove if not used
    // if( document.querySelector('.compare_count') ||
    //     document.querySelector('.wishlist_count') ) {
    //     import('modules/save_items/init');
    // }
    
    // cookie consent
    // if( !get_cookie('ff_cookie_consent') ) {
    //     import('modules/cookie_consent/simple/simple')
    // }
}

// Show/hide Section
document.addEventListener('DOMContentLoaded', function () {
    const sections = document.querySelectorAll('.show-hide');

    sections.forEach(section => {
        const button = section.querySelector('.expand-btn');
        if (!button) return;
        const formContainer = section.querySelector('.hidden-box');
        if (!formContainer) return;
        const buttonText = button.querySelector('.elementor-button-text');
        if (!buttonText) return;
        const initialText = buttonText.textContent;

        button.addEventListener('click', function (e) {
            e.preventDefault();
            button.classList.toggle('active');
            formContainer.classList.toggle('active');
            // Optional: Toggle the button text
            // buttonText.textContent = button.classList.contains('active') ? 'Close' : initialText;
        });
    });
});


// Read more for mobile
function mobile_read_more() {
   if (window.innerWidth > 768) return; 

    document.querySelectorAll('.mobile-read-more .elementor-widget-container').forEach(container => {
        const paragraphs = container.querySelectorAll('p');
        if (paragraphs.length <= 1) return;

        const fullText = Array.from(paragraphs).map(p => `<p>${p.innerHTML}</p>`).join('');
        const firstParagraph = `<p>${paragraphs[0].innerHTML}</p>`;

        container.innerHTML = `${firstParagraph}<span class="read-more-toggle">Read more</span>`;

        const toggle = container.querySelector('.read-more-toggle');

        toggle.addEventListener('click', () => {
            container.innerHTML = fullText; 
        });
    });
}
